import { WorkspaceAccessRole } from '../types/WorkspaceAccess';

export type WorkspaceAccessEntry = {
  userId: number;
  role: string;
};

/**
 * Resolves the current user's workspace role from the access list.
 * Returns undefined if the access list hasn't loaded yet or the user is not logged in.
 */
export function resolveWorkspaceRole(
  accessList: WorkspaceAccessEntry[] | undefined,
  userId: number | undefined
): WorkspaceAccessRole | undefined {
  if (!accessList) return undefined;
  if (!userId) return undefined;

  const matchedAccess = accessList.find((w) => w.userId === userId);
  if (!matchedAccess) return WorkspaceAccessRole.Member;

  return matchedAccess.role?.toLowerCase() === WorkspaceAccessRole.Owner.toLowerCase()
    ? WorkspaceAccessRole.Owner
    : WorkspaceAccessRole.Member;
}
